import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	header: {
		padding: "30px 32px 0",
		position: "relative"
	},
	checkCircle: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 34,
		height: 34,
		borderRadius: "50%",
		backgroundColor: themeColors.colors.success[50],
		flexShrink: 0
	},
	titleRow: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		marginBottom: 4
	},
	checkGlyph: {
		color: themeColors.colors.success[600],
		fontSize: 18,
		fontWeight: 700,
		lineHeight: 1
	},
	title: {
		color: themeColors.colors.system.gray[900],
		fontSize: "24px",
		fontWeight: 500,
		lineHeight: 1.3,
		letterSpacing: "-0.015em"
	},
	subtitle: {
		marginTop: 10,
		color: themeColors.colors.system.gray[600],
		fontSize: "14.5px",
		fontWeight: 400,
		lineHeight: 1.6
	},
	leadNameBold: {
		fontWeight: 600,
		color: themeColors.colors.system.gray[900]
	},
	walletCard: {
		margin: "22px 32px 0",
		border: `1px solid ${themeColors.colors.system.gray[100]}`,
		borderRadius: 14,
		overflow: "hidden"
	},
	walletTopSection: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		backgroundColor: themeColors.colors.system.gray[50],
		padding: "18px 22px"
	},
	walletLeftColumn: {
		display: "flex",
		flexDirection: "column",
		gap: 2
	},
	walletLabel: {
		color: themeColors.colors.system.gray[400],
		fontSize: "11px",
		fontWeight: 700,
		letterSpacing: "0.1em",
		textTransform: "uppercase"
	},
	walletTotal: {
		color: themeColors.colors.system.gray[900],
		fontSize: "30px",
		fontWeight: 500,
		lineHeight: 1.1
	},
	walletStatus: {
		color: themeColors.colors.system.gray[400],
		fontSize: "13px",
		fontWeight: 400
	},
	walletRightColumn: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-end",
		gap: 2
	},
	walletCount: {
		color: themeColors.colors.system.gray[900],
		fontSize: "14px",
		fontWeight: 600
	},
	walletValidity: {
		color: themeColors.colors.system.gray[400],
		fontSize: "13px",
		fontWeight: 400
	},
	walletBottomSection: {
		backgroundColor: themeColors.colors.system.gray[50],
		padding: "18px 22px 20px"
	},
	stepper: {
		display: "flex",
		alignItems: "center",
		gap: 0
	},
	stepCircle: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 26,
		height: 26,
		borderRadius: "50%",
		flexShrink: 0,
		fontSize: 13,
		fontWeight: 700
	},
	stepCircleCompleted: {
		backgroundColor: themeColors.colors.system.purple[500],
		color: themeColors.colors.system.gray[50]
	},
	stepCircleCurrent: {
		backgroundColor: themeColors.colors.system.purple[500],
		color: themeColors.colors.system.gray[50]
	},
	stepCirclePending: {
		backgroundColor: "transparent",
		border: `2px solid ${themeColors.colors.system.purple[200]}`,
		color: themeColors.colors.system.gray[400]
	},
	stepCircleGlyph: {
		color: "inherit"
	},
	stepConnector: {
		flex: 1,
		height: 3,
		minWidth: 20
	},
	stepConnectorCompleted: {
		backgroundColor: themeColors.colors.system.purple[500]
	},
	stepConnectorPending: {
		backgroundColor: themeColors.colors.system.gray[100]
	},
	stepLabel: {
		color: themeColors.colors.system.gray[400],
		fontSize: "12px",
		fontWeight: 500,
		marginTop: 6,
		textAlign: "center"
	},
	stepLabelCompleted: {
		color: themeColors.colors.system.gray[900],
		fontWeight: 600
	},
	stepWrapper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		flex: 1
	},
	footer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "20px 32px 26px",
		marginTop: "auto"
	},
	indicateAnotherLink: {
		background: "none",
		border: "none",
		color: themeColors.colors.system.gray[600],
		fontSize: "13px",
		fontWeight: 400,
		cursor: "pointer",
		padding: 0,
		transition: "color 0.2s ease",
		"&:hover": {
			color: themeColors.colors.system.gray[900]
		}
	},
	partnerButton: {
		padding: "15px 24px",
		borderRadius: 12,
		border: "none",
		backgroundColor: themeColors.colors.system.purple[500],
		color: themeColors.colors.system.gray[50],
		fontSize: "15px",
		fontWeight: 600,
		cursor: "pointer",
		boxShadow: `0 12px 26px ${ColorUtil.hexToRgba(colors.purple[400], 0.3)}`,
		whiteSpace: "nowrap",
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[600]
		}
	},
	partnerButtonLabel: {
		display: "flex",
		alignItems: "center",
		gap: 6
	},
	externalArrowIcon: {
		fontSize: 15
	}
}))

export default useStyles
